import { Model } from './core';

export default class Menu extends Model {
  static get endpoint() {
    return 'wp-api-menus/v2/menu-locations';
  }
}
